export enum AssignmentStatus {
  PENDIENTE = 'PENDIENTE',
  ENTREGADA = 'ENTREGADA',
  VENCIDA = 'VENCIDA',
  APROBADA = 'APROBADA',
  EN_REVISION = 'EN_REVISION',
}
